

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"de","iso":"de","file":"de.ts","dir":"ltr"}],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "/opt/build/repo/lang",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://my.hausheld.ch",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"analysis/index":{"de":"/analyse/"},"analysis/create":{"de":"/immobilie-erfassen/"},"analysis/_component":{"de":"/analyse/komponente/:component?"},"auth/register":{"de":"/registration/"},"login":{"de":"/anmelden/"},"auth/forgot-password":{"de":"/passwort-vergessen/"},"auth/password-reset/_passwordResetMailSent":{"de":"/passwort-zuruecksetzen/:passwordResetMailSent?"},"auth/new-password/_token":{"de":"/neues-passwort/:token?"},"conditions/index":{"de":"/allgemeine-geschaeftsbedingungen/"},"dataProtection/index":{"de":"/datenschutz/"},"impressum/index":{"de":"/impressum/"},"profile/index":{"de":"/profil/"},"profile/settings":{"de":"/profil/einstellungen/"},"projects/index":{"de":"/renovationen/"},"projects/create":{"de":"/renovation-erstellen/"},"projects/_project":{"de":"/renovation/:project?"},"real-estate/index":{"de":"/immobilie/"},"real-estate/_realEstate":{"de":"/immobilie/:realEstate?"},"tools/index":{"de":"/tools/"},"tools/counselor":{"de":"/tools/ratgeber/"},"tools/craftsmen":{"de":"/tools/handwerker/"},"tools/finance":{"de":"/tools/finanzen/"},"todos/index":{"de":"/to-dos/"},"welcome/_craft":{"de":"/willkommen/:craft?"},"appointments/index":{"de":"/termine/"},"tools/appointments":{"de":"/termine/"},"craftsmen/index":{"de":"/handwerker/"},"tools/documents":{"de":"/tools/meine-unterlagen/"},"mortgage/index":{"de":"/meine-finanzen/"},"tools/invoice":{"de":"/tools/meine-rechnungen/"},"mortgage/realEstateReview":{"de":"/immobilien-bewertung/"},"mortgage/swissLife":{"de":"/swiss-life/"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  fallbackLocale: "de",
  seo: false,
  normalizedLocales: [{"code":"de","iso":"de","file":"de.ts","dir":"ltr"}],
  localeCodes: ["de"],
  additionalMessages: [],
}

export const localeMessages = {
  'de.ts': () => import('../../../../lang/de.ts' /* webpackChunkName: "lang-de.ts" */),
}
